/** Shared React Query keys — one cache per entity across all pages. */
export const queryKeys = {
  spa: {
    courses: ['spa', 'courses'],
    trainers: ['spa', 'trainers'],
    classrooms: ['spa', 'classrooms'],
    sessions: ['spa', 'sessions'],
    trainingSessions: ['spa', 'training-sessions'],
    certifications: ['spa', 'certifications'],
  },
  formation: {
    enrollmentBundle: ['formation', 'enrollment-bundle'],
    studentsCatalog: ['formation', 'students', 'catalog'],
    studentsCatalogLite: ['formation', 'students', 'catalog-lite'],
    payments: ['formation', 'payments'],
    evaluations: ['formation-evaluations'],
    dashboard: ['formation', 'dashboard'],
    student: (id) => ['formation', 'student', id],
  },
  settings: {
    organization: ['settings', 'organization'],
  },
  benefits: {
    dashboard: ['benefits', 'dashboard'],
  },
  reports: {
    source: ['reports', 'source'],
  },
};

/** Legacy aliases — prefer queryKeys above in new code. */
export const SPA_COURSES_KEY = queryKeys.spa.courses;
export const SPA_TRAINERS_KEY = queryKeys.spa.trainers;
export const SPA_CLASSROOMS_KEY = queryKeys.spa.classrooms;
export const SPA_TRAINING_SESSIONS_KEY = queryKeys.spa.trainingSessions;
export const SPA_SESSIONS_KEY = queryKeys.spa.sessions;
export const FORMATION_ENROLLMENT_BUNDLE_KEY = queryKeys.formation.enrollmentBundle;
export const FORMATION_STUDENTS_CATALOG_KEY = queryKeys.formation.studentsCatalog;
export const FORMATION_PAYMENTS_QUERY_KEY = queryKeys.formation.payments;
export const BENEFITS_DASHBOARD_KEY = queryKeys.benefits.dashboard;
export const REPORTS_SOURCE_KEY = queryKeys.reports.source;
export const ORGANIZATION_SETTINGS_KEY = queryKeys.settings.organization;

/** Map entity names to shared spa keys. */
export const ENTITY_QUERY_KEY_MAP = {
  courses: queryKeys.spa.courses,
  trainers: queryKeys.spa.trainers,
  classrooms: queryKeys.spa.classrooms,
  sessions: queryKeys.spa.sessions,
  'training-sessions': queryKeys.spa.trainingSessions,
  certifications: queryKeys.spa.certifications,
};

export function queryKeyForEntity(entityName) {
  return ENTITY_QUERY_KEY_MAP[entityName] || ['entity', entityName];
}
